export * from './sidebar.directive';



// WEBPACK FOOTER //
// ./src/app/directives/sidebar/index.ts